export const ENDPOINTS = {
  LOGIN: {
    URL: 'login',
    METHOD: 'post'
  },
  CHANGE_PASSWORD: {
    URL: 'change-password',
    METHOD: 'post'
  },
  BEFORE_RESET_PASSWORD: {
    URL: 'before-reset-password',
    METHOD: 'post'
  },
  RESET_PASSWORD: {
    URL: 'reset-password',
    METHOD: 'post'
  },
  GOOGLE_DISTANCE: {
    URL: 'https://maps.googleapis.com/maps/api/distancematrix/json',
    METHOD: 'get'
  },
  HERE_API_PLACES: {
    URL: 'https://places.cit.api.here.com/places/v1/autosuggest',
    METHOD: 'get'
  },
  HERE_API_DISTANCE: {
    URL: 'https://route.api.here.com/routing/7.2/calculateroute.json',
    METHOD: 'get'
  },
  GET_DISTANCE: {
    URL: 'api/get-distanza',
    METHOD: 'post'
  },
  VERIFY_TARGA: {
    URL: 'api/targa-verify',
    METHOD: 'post'
  },
  NOTA_SPESE: {
    GET_ALL_NOTE: {
      URL: 'api/nota-spesa/get-all',
      METHOD: 'post'
    },
    GET_ALL_NOTE_DA_MODIFICARE: {
      URL: 'api/nota-spesa/get-da-modifica',
      METHOD: 'post'
    },
    GET_ALL_RICHIESTE_MENSILE: {
      URL: 'api/nota-spesa/get-richieste-mensile',
      METHOD: 'post'
    },
    GET_STATISTICA_RICHIESTE: {
      URL: 'api/nota-spesa/get-richieste-statistica',
      METHOD: 'post'
    },
    GET_SPESE_AZIENDALE: {
      URL: 'api/nota-spesa/get-aziendale',
      METHOD: 'post'
    },
    GET_SPESE_AUTORIZZATE: {
      URL: 'api/richieste-autorizzate',
      METHOD: 'post'
    },
    INVIA_AUTORIZZAZIONE: {
      URL: 'nota-spesa/invia-richiesta-autorizzazione',
      METHOD: 'post'
    },
    ADD_NOTA: {
      URL: 'nota-spesa/add',
      METHOD: 'post'
    },
    GET_NOTE: {
        URL: 'nota-spesa/get-note',
        METHOD: 'post'
    },
    FIRMA_NOTA: {
        URL: 'nota-spesa/firma-nota-spesa',
        METHOD: 'post'
    },
    GET_NOTA: {
        URL: 'nota-spesa/get-nota',
        METHOD: 'POST'
    },
    UPDATE_NOTA: {
          URL: 'nota-spesa/update-nota',
          METHOD: 'POST'
      },
    REINVIA_CODICE: {
        URL: 'nota-spesa/reinvia-codice',
        METHOD: 'POST'
      },
    GET_VALUTE: {
        URL: 'http://data.fixer.io/api/',
        METHOD: 'GET'
    },
    EXIST_NOTA: {
        URL: 'nota-spesa/exist-nota',
        METHOD: 'POST'
    },
    REMOVE_NOTA_SPESA: {
        URL: 'nota-spesa/remove-nota-spesa',
        METHOD: 'POST'
    },
    CHIUDI_MESE: {
        URL: 'nota-spesa/chiudi-mese',
        METHOD: 'POST'
    },
    GET_DETTAGLIO_CATEGORIA: {
        URL: 'api/nota-spesa/get-dettaglio-categoria',
        METHOD: 'POST'
    }
  },
  TARGA: {
      GET_ALL: {
        URL: 'api/targa/get-all',
        METHOD: 'post'
      },
      NEW: {
        URL: 'nota-spesa/targa/new',
        METHOD: 'post'
      },
      ADD_LOGIN: {
        URL: 'api/targa/login-personale',
        METHOD: 'post'
      },
      REMOVE_LOGIN: {
        URL: 'api/targa/login-personale',
        METHOD: 'delete'
      }
    },
  TRATTA: {
      GET_ALL: {
        URL: 'api/tratta/get-all',
        METHOD: 'post'
      },
      GET_ALL_CITTA: {
        URL: 'api/citta/get-all',
        METHOD: 'post'
      },
      GET_ALL_VIA: {
        URL: 'api/via/get-all',
        METHOD: 'post'
      },
      NEW: {
        URL: 'nota-spesa/tratta/new',
        METHOD: 'post'
      }
    },
  ADMIN_GESTIONE: {
      GET_NOTE_VERIFICA: {
        URL: 'gestione-admin/spesa/get-all-verifica',
        METHOD: 'post'
      },
      GET_REPORT_MENSILE: {
        URL: 'gestione-admin/report',
        METHOD: 'post'
      },
      GET_PREAUTORIZZATI: {
        URL: 'api/pre-autorizzati',
        METHOD: 'get'
      },
      GET_RICHIESTE: {
        URL: 'api/richieste-autorizzazioni',
        METHOD: 'get'
      },
      GET_ALLUSERS: {
        URL: 'api/utenti/get-all',
        METHOD: 'post'
      },
      CONFIRM_NOTA_SPESA: {
        URL: 'gestione-admin/spesa/confirm',
        METHOD: 'post'
      },
      GET_DETAGLIO_SPESA: {
        URL: 'gestione-admin/spesa/show-dettaglio',
        METHOD: 'post'
      },
      PROTOCOLLA_SPESA: {
        URL: 'gestione-admin/spesa/protocolla',
        METHOD: 'post'
      },
      PROTOCOLLO_CONFERMA: {
        URL: 'gestione-admin/spesa/protocollo-conferma',
        METHOD: 'post'
      },
      INVIA_SPESA: {
        URL: 'gestione-admin/spesa/invia',
        METHOD: 'post'
      },
      SALVA_PREAUTORIZZATO: {
        URL: 'gestione-admin/pre-autorizzato',
        METHOD: 'post'
      },
      ELIMINA_PREAUTORIZZATO: {
        URL: 'gestione-admin/rimuovi-pre-autorizzato',
        METHOD: 'post'
      },
      ELIMINA_AUTORIZZAZIONE: {
        URL: 'gestione-admin/annulla-autorizzazione',
        METHOD: 'post'
      },
      CONFERMA_AUTORIZZAZIONE: {
        URL: 'gestione-admin/conferma-autorizzazione',
        METHOD: 'post'
      },
    },
  SAMM_GESTIONE: {
      GET_NOTE_VERIFICA: {
        URL: 'gestione-samm/spesa/get-all-verifica',
        METHOD: 'post'
      },
      CONFIRM_NOTA_SPESA: {
        URL: 'gestione-samm/spesa/confirm',
        METHOD: 'post'
      },
      GET_AUTO_VERIFICA: {
        URL: 'gestione-samm/auto/get-all-verifica',
        METHOD: 'post'
      },
      GET_AUTO_LIBRETTO: {
        URL: 'gestione-samm/auto/libretto',
        METHOD: 'post'
      },
      GET_TRATTE_VERIFICA: {
        URL: 'gestione-samm/tratta/get-all-verifica',
        METHOD: 'post'
      },
      CHANGE_TRATTA_ITEM: {
        URL: 'gestione-samm/tratta/change-item',
        METHOD: 'post'
      },
      TOGGLE_TRATTA_ITEM: {
        URL: 'gestione-samm/tratta/toggle-item',
        METHOD: 'put'
      },
      SET_COEFFICIENTE: {
        URL: 'gestione-samm/auto/set-coefficiente',
        METHOD: 'post'
      },
      GET_DETAGLIO_SPESA: {
        URL: 'gestione-samm/spesa/show-dettaglio',
        METHOD: 'post'
      },
      INVIA_SPESA: {
        URL: 'gestione-samm/spesa/invia',
        METHOD: 'post'
      },
      UPDATE_AUTO: {
        URL: 'gestione-samm/auto',
        METHOD: 'put'
      },
    },
  REPORT: {
      GET_MENSILE: {
        URL: 'report/mensile',
        METHOD: 'post'
      },
      GET_NON_PROTOCOLLATE: {
        URL: 'report/non-protocollate',
        METHOD: 'post'
      },
      GET_PROTOCOLLO_SPESA: {
        URL: 'report/spesa/get-protocollo',
        METHOD: 'post'
      },
      PROTOCOLLA_SPESA: {
        URL: 'report/spesa/protocolla',
        METHOD: 'post'
      },
      BEFORE_PROTOCOLLA_SPESA: {
        URL: 'report/spesa/before-protocollo',
        METHOD: 'post'
      },
      
    },
    SETTINGS: {
      RESET_PASSWORD: {
        URL: 'impostazioni/reset-password',
        METHOD: 'post'
      },
    },
}


// WEBPACK FOOTER //
// ./modules/Home/views/src/services/endpoints.js